import React from 'react'
import { SiteLogo, Icon, T } from 'components'
import Success from './Success/Success'
import Upgrade from './Upgrade/Upgrade'
import StyledPayment from './StyledPayment'

const routes = [
  { to: '/payment/upgrade', component: Upgrade },
  { to: '/payment/success', component: Success },
]

const Payment = ({ history }) => {
  const route = routes.find(e => location.pathname.includes(e.to)) || routes[0]
  const Content = route.component

  return (
    <StyledPayment>
      <header className="app-header">
        <SiteLogo />
        {route.to == '/payment/upgrade' && (
          <a className="app-back" onClick={() => history.goBack()}>
            <Icon name="angle-left" />
            <T label="actions/back" />
          </a>
        )}
      </header>
      <Content />
    </StyledPayment>
  )
}

export default Payment
